// extracted by mini-css-extract-plugin
export default {"main":"styles_main__p0qO7","box":"styles_box__vynL6","leftCol":"styles_leftCol__iCQZT","title":"styles_title__BM5RK","rightCol":"styles_rightCol__mwOHR"};